import { ToastIntent } from "@fluentui/react-components";
import { makeAutoObservable } from "mobx";
interface toastInfoType {
  show?: boolean;
  message?: string;
  status?: ToastIntent | "progress" | "avatar"
}

export default class Common {
  menuCollapsed = false;
  EnabledOrNot = false;
  showMessageBar = false;
  progressHidden = false;
  toastConfig = "{}";
  invitationUserOperation = "";
  currentCustomerUserId = "";
  currentCustomerUserDialog = false;
  showProcedureMessageBar = false;
  updateToken = false;
  errorMessage = "";
  constructor () {
    /**
     * state
     */
    this.menuCollapsed = false;
    this.EnabledOrNot = window.localStorage.getItem("EnabledOrNot") === "true" || false;
    this.showMessageBar = window.localStorage.getItem("showMessageBar") === "true" || false;
    this.progressHidden = window.localStorage.getItem("progressHidden") === "true" || false;
    this.invitationUserOperation = window.localStorage.getItem("invitationUserOperation") || "";
    this.currentCustomerUserId = window.localStorage.getItem("currentCustomerUserId") || "";
    this.currentCustomerUserDialog = window.localStorage.getItem("currentCustomerUserDialog") === "true" || false;
    this.showProcedureMessageBar = window.localStorage.getItem("showProcedureMessageBar") === "true" || false;
    this.toastConfig = window.localStorage.getItem("toastConfig") || "{}";
    this.updateToken = window.localStorage.getItem("updateToken") === "true" || false;
    this.errorMessage = window.localStorage.getItem("MAP_Account_ErrorMessage") || "";

    makeAutoObservable(this);
  }

  /**
   * computed
   */

  get toastInfo () {
    return JSON.parse(this.toastConfig);
  }

  get collapsed () {
    return this.menuCollapsed;
  }

  get mapErrorMessage () {
    return this.errorMessage;
  }

  /**
   * action
   */
  setMenuCollapsed (val: boolean) {
    this.menuCollapsed = val;
  }

  setEnabledOrNot (val: boolean) {
    this.EnabledOrNot = val;
    window.localStorage.setItem("EnabledOrNot", this.EnabledOrNot + "");
  }

  setshowMessageBar (val: boolean) {
    this.showMessageBar = val;
    window.localStorage.setItem("showMessageBar", this.showMessageBar + "");
  }

  setshowProcedureMessageBar (val: boolean) {
    this.showMessageBar = val;
    window.localStorage.setItem("showProcedureMessageBar", this.showMessageBar + "");
  }

  setprogressHidden (val: boolean) {
    this.progressHidden = val;
    window.localStorage.setItem("progressHidden", this.progressHidden + "");
  }

  setInvitationUserOperation (val: string) {
    this.invitationUserOperation = val;
    window.localStorage.setItem("invitationUserOperation", this.invitationUserOperation);
  }

  setCurrentCustomerUserId (val: string) {
    this.currentCustomerUserId = val;
    window.localStorage.setItem("currentCustomerUserId", this.currentCustomerUserId);
  }

  setCurrentCustomerUserDialog (val: boolean) {
    this.currentCustomerUserDialog = val;
    window.localStorage.setItem("currentCustomerUserDialog", this.currentCustomerUserDialog + "");
  }

  setToastConfig (val: toastInfoType) {
    this.toastConfig = JSON.stringify(val || {});
    window.localStorage.setItem("toastConfig", this.toastConfig);
  }

  setUpdateToken (val: boolean) {
    this.updateToken = val;
    window.localStorage.setItem("updateToken", this.updateToken + "");
  }

  setMapErrorMessage (val: string) {
    this.errorMessage = val;
    window.localStorage.setItem("MAP_Account_ErrorMessage", val);
  }
}
